<template>
    <div class="footer-nav">
      <div class="disclaimer-container" v-if="popupDismissed == 0">
      <div class="disclaimer-overlay"></div>
        <div class="disclaimer-box">
            <div class="disclaimer-text">
                <strong>By using Thetanuts dApp, I agree to the (1) Important Disclaimer; (2) the Terms of Use; and (3) Privacy Policy.</strong>
                <p class="disclaimer-text__paragraph">
                    <ul>
                        <li>I am not a person or entity who resides in, are citizens of, are incorporated in , or have a registered office in the USA or any Prohibited Jurisdictions, as defined in the Terms of Use </li>
                        <li>I will not in the future access this site or use the Thetanuts dApp while located within the United States or any Prohibited Jurisdictions, as defined in the Terms of Use</li>
                        <li>I am lawfully permitted to access this site and use the Thetanuts dApp under the laws of the jurisdiction on which I reside and am located </li>
                        <li>I understand the risks associated with entering into and using Thetanuts Finance protocols </li>
                    </ul>
                </p>
                <AppButton @click.native="closePopup" class="disclaimer-btn--bg-color">
                    Agree and Proceed
                </AppButton>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import AppButton from "./LandingPage/AppButton.vue";

export default {
  components: {
      AppButton
  },
  data() {
    return {
      popupDismissed: false,
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    closePopup() {
      localStorage.setItem("popupDismissed",1);
      this.popupDismissed = true;
    },
  },
  mounted() {
    if(localStorage.getItem("popupDismissed") == null){
      localStorage.setItem("popupDismissed",0);
    } else{
      this.popupDismissed = localStorage.getItem("popupDismissed");
    }
  },
};
</script>

<style lang="scss">
@import "./resources/sass/_variables.scss";

.disclaimer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.7);
  z-index: 99;
}

.disclaimer-container {
  display: flex;
  justify-content: center;
}

.btn-sign {
  width: 100%;
  background: linear-gradient(208.27deg, #6ee29f 0%, #27ae60 95.3%);
  display: inline-block;
  padding: 0.38195vw 1.11111vw !important;
  position: relative;
  border-color: transparent;
  z-index: 1;
  // font-family: Exo;
  font-family: 'Sofia Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 9px;
  line-height: 14px !important;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  border-radius: 0.6vmax !important;

  @media only screen and (min-width: 992px) {
    font-size: 0.8vw;
    line-height: 1.2vmax !important;
  }
}

.footer-nav {
  a,
  a:hover {
    text-decoration: none !important;
  }
  .nav-bottom {
    margin: auto;
  }
}
.disclaimer-text {
  width: 100%;
  // font-family: Exo;
  font-family: 'Sofia Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  //   line-height: 1.4vmax;
  color: $primary-4;
  // margin: auto;
  text-align: left;

  @media only screen and (min-width: 992px) {
    font-size: 1vmax;
    // margin: auto 20px;

  }

  @media only screen and (min-width: 1440px) {
    // margin: auto 1.3888888888888888vw;
    // font-size: 14px;
    // line-height: 20px;
  }

  strong {
    font-family: Sofia Sans;
    font-size: 19px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0px;
    text-align: center;
    display: block;

    @media only screen and (min-width: 1440px) {
      // font-size: 1.9444444444444444vw; // 28px
    }

    // @media only screen and (min-width: 1666px) {
    //   font-size: 1.680672268907563vw;
    //   line-height: 2.4009603841536613vw;
    // }
  }

  .disclaimer-text__paragraph {
    font-family: Sofia Sans;
    font-size: 17px;
    font-weight: 300;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: left;
    margin: 10px 0;

    // @media only screen and (min-width: 1666px) {
    //   font-size: 1.3205282112845138vw;
    //   line-height: 1.8007202881152462vw;
    //   margin: 0.6002400960384153vw 0;
    // }
  }
}
.disclaimer-box {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  position: fixed;
  width: 90%;
  bottom: 10px;
  // left: calc((100vw - 550px) / 2);
  // bottom: 40px;
  padding: 15px;
  z-index: 999;
  // background: #1d1d1d;
  background: #283841;
  box-shadow: 0px 24px 62px 14px rgba(17, 17, 17, 0.32);
  border-radius: 20px;
  // border: 0.3px solid rgba(39, 174, 96, 0.8);

  @media only screen and (min-width: 992px) {
    // bottom: 40px;
    // width: 40%;
    // height: 55%;
    width: 400px;
    height: min-content;
    top: 50%;
    transform: translateY(-50%);
    padding: 25px;
    // padding: 40px;
    border-radius: 20px;
  }

  @media only screen and (min-width: 1440px) {
    // width: 90%;
    padding: 1.7361111111111112vw; // 25px
    // padding: 2.4009603841536613vw; // 40px
    border-radius: 1.3888888888888888vw;
    // left: calc((100vw - 650px) / 2);
  }

  // @media only screen and (min-width: 1666px) {
  //   width: 33.01320528211284vw;
  // }
}
.disclaimer-button {
  width: 100%;
  //padding: 10px 30px;
  background: $gradient-1;
  display: inline-block;
  padding: 0.38195vw 1.11111vw !important;
  position: relative;
  border-color: transparent;
  // background: linear-gradient(208.27deg,
  //         rgba(110, 226, 159, 1) 0%,
  //         rgba(98, 113, 255, 1) 95.3%);
  //box-shadow: 3px 5px 10px rgba(64, 149, 197, 0.3);
  z-index: 1;
  // font-family: Exo;
  font-family: 'Sofia Sans';
  font-style: normal;
  font-weight: 600;
  //font-size: 14px;
  font-size: 0.8vw; //$text-normal;
  line-height: 1.2vmax !important;
  text-align: center;
  text-transform: uppercase;
  color: $primary-4;
  border-radius: 0.6vmax !important;
}

.close-button {
  color: white;
  font-size: 12px;
  font-weight: 600;
}
.close-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 6px;
  right: 15px;
  cursor: pointer;
}

.disclaimer-btn--bg-color {
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    width: 80%;
    
    &:before {
      background-color: #283841 !important;
    }
  }
}
</style>
